import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trendIcon', standalone: true })
export class TrendIconPipe implements PipeTransform {
  transform(trend: number | null | undefined): string {
    if (trend == null) return 'remove';
    if (trend > 0) return 'arrow_upward';
    if (trend < 0) return 'arrow_downward';
    return 'remove';
  }
}
